<template>
  <BaseDialog
    type="basic"
    :is-open="isOpen"
    @close="emits('dismiss')"
    :title="$t('unsaved-changes.title')"
    :description="$t('unsaved-changes.description')"
  >
    <div class="flex w-full flex-row justify-end gap-1 pt-4">
      <BaseTextButton @click="emits('confirm')" size="M">{{
        $t('unsaved-changes.confirm')
      }}</BaseTextButton>
      <BaseTextButton @click="emits('dismiss')" size="M" color="filled">{{
        $t('unsaved-changes.dismiss')
      }}</BaseTextButton>
    </div>
  </BaseDialog>
</template>
<script setup lang="ts">
  import BaseDialog from '../base/dialog/BaseDialog.vue'
  import BaseTextButton from '../base/button/text-button/BaseTextButton.vue'

  defineProps<{
    isOpen: boolean
  }>()

  const emits = defineEmits<{
    (e: 'confirm'): void
    (e: 'dismiss'): void
  }>()
</script>
